module.exports = __webpack_public_path__ + "static/media/flat.5352be52.svg";